// Source: app/scripts/controllers/edit-authorization-case.js
Auction.controller('EditAuthorizationCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  '$route',
  '$timeout',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'ModalScrollLock',
  function ($scope, $filter, $routeParams, $location, $route, $timeout, toaster, crudService, $modal, Downloader, Messages, ModalScrollLock) {

    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/authorization_cases/:id'
      },
      'editAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_cases/edit_authorization_case'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_cases/submit_authorization_case'
      },
      'getAuthorizationById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/authorizations/by_authorization_case_id/:id'
      },
      'getPortalLicenceById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_licences/by_authorization_case_id/:id'
      },
      'editAuthorization': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/authorizations/edit_authorization'
      },
      'editPortalLicence': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/portal_licences/edit_portal_licence'
      },
      'getDocumentTypeByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_document_types/by_code'
      }
    });


    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );


    var authorizationTariffService = crudService('authorization_tariffs', {
      'getAuthorizationTariffsForCaseId': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/authorization_tariffs/by_authorization_case_id/:id'
      },
      'addAuthorizationTariffToAuthorizationCase': {
        method: 'POST',
        url: '/data/rest/authorization_tariffs/add_authorization_tariff_to_authorization_case'
      },
      'deleteAuthorizationTariff': {
        method: 'DELETE',
        url: '/data/rest/authorization_tariffs/:id'
      },
      'findTariffByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/tariffs/by_code'
      }
    });


    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsTab = rt;
      // $location.search(search);
    };


    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsDocumentTab = rt;
      // $location.search(search);
    };


    function loadAuthorizationCaseData(caseId) {
      authorizationTariffService.getAuthorizationTariffsForCaseId({id: caseId}, function (data) {
        $scope.authorizationTariffs = data;
      });
      caseService.getAuthorizationById({id: caseId}, function (data) {
        $scope.authorization = data;
      });
      caseService.getPortalLicenceById({id: caseId}, function (data) {
        $scope.licence = data;
      });
    }

    function initEntity() {

      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {

        portalCase = data;
        if(portalCase.caseStatus != 'DRAFT' && portalCase.caseStatus != 'RETURNED_FOR_CORRECTIONS'){
          $scope.viewAuthorizationCase(portalCase.id);
        }
        $scope.allowEdit = true;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.authorizationTariff = {};
        $scope.foundAuthorizationTafiff = "";

        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
          console.log('$scope in edit');
          console.log($scope);
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;
          // $location.path("/web_portal/web_portal_home_page/create_general_case");
          console.log('$scope in edit');
          console.log($scope);
        }
        $scope.activateTab(1);
        loadAuthorizationCaseData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });


    }


    initEntity();


    $scope.editPortalCaseMetadata = function (portalCase) {
      caseService.editAuthorizationCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };


    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });

    $scope.modalAddOrEditAuthorizationPdfDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_authorization_request_pdf_document.html',
      show: false
    });

    $scope.modalAddOrEditAuthorizationDocxDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_authorization_request_docx_document.html',
      show: false
    });

    $scope.modalAddOrEditLicencePdfDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_licence_request_pdf_document.html',
      show: false
    });

    $scope.modalAddOrEditLicenceDocxDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_licence_request_docx_document.html',
      show: false
    });

    $scope.modalAddOrEditComplaintPdfDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_complaint_pdf_document.html',
      show: false
    });

    $scope.modalSubmitCaseConfirm = $modal({
      scope: $scope,
      // title: $filter('translate')('portal.forum'),
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
    });

    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditCaseDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.outgoingDocumentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };



    $scope.showAddNewAuthorizationRequestPdfForm = function () {
      caseService.getDocumentTypeByCode({code: 'AUTHORIZATION'}, function (data) {
        $scope.portalDocument = {};
        $scope.portalDocument.documentType = data;
        $scope.modalAddOrEditAuthorizationPdfDocument.show();
      })
    };

    $scope.showAddNewAuthorizationRequestDocxForm = function () {
      caseService.getDocumentTypeByCode({code: 'AUTH_WORD'}, function (data) {
        $scope.portalDocument = {};
        $scope.portalDocument.documentType = data;
        $scope.modalAddOrEditAuthorizationDocxDocument.show();
      })   };

    $scope.showAddNewLicenceRequestPdfForm = function () {
      caseService.getDocumentTypeByCode({code: 'LICENCE'}, function (data) {
        $scope.portalDocument = {};
        $scope.portalDocument.documentType = data;
        $scope.modalAddOrEditLicencePdfDocument.show();
      })  };

    $scope.showAddNewLicenceRequestDocxForm = function () {
      caseService.getDocumentTypeByCode({code: 'LICENCE_WORD'}, function (data) {
        $scope.portalDocument = {};
        $scope.portalDocument.documentType = data;
        $scope.modalAddOrEditLicenceDocxDocument.show();
      })  };

    $scope.showAddNewComplaintPdfForm = function () {
      caseService.getDocumentTypeByCode({code: 'COMPLAINT_GENERAL'}, function (data) {
        $scope.portalDocument = {};
        $scope.portalDocument.documentType = data;
        $scope.modalAddOrEditComplaintPdfDocument.show();
      })  };

    $scope.deletePortalDocument = function () {
      console.log('vo delete funkcija $scope');
      console.log($scope);

      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.outgoingDocumentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.addAuthorizationTariff = function (authorizationTariff) {
      authorizationTariffService.findTariffByCode({code: authorizationTariff.code}, function (data) {
        if (data.id) {
          $scope.authorizationTariff.tariff = data;
          $scope.authorizationTariff.description = data.labelSQ;
          $scope.foundAuthorizationTafiff = "";
        } else {
          $scope.authorizationTariff.tariff = null;
          $scope.foundAuthorizationTafiff = "portal.tariff_not_found";
        }
        if (authorizationTariff.tariff && authorizationTariff.tariff.id) {

          authorizationTariff.authorizationCase = $scope.entity.portalCase;
          authorizationTariffService.addAuthorizationTariffToAuthorizationCase(authorizationTariff, function (data) {
            authorizationTariffService.getAuthorizationTariffsForCaseId({id: $scope.entity.portalCase.id}, function (data) {
              $scope.authorizationTariffs = data;
              $scope.authorizationTariff = {};
            })
          });

          $scope.authorizationTariff = {};
        } else {
          Messages.error('portal.invalid_tariff');
        }
      });

      // $scope.authorizationTariff.tariff = null;
      // $scope.authorizationTariff.quantity = null;
      // $scope.authorizationTariff.value = null;

    };

    $scope.searchTariffByCode = function (code) {
      authorizationTariffService.findTariffByCode({code: code}, function (data) {
        if (data.id) {
          $scope.authorizationTariff.tariff = data;
          $scope.authorizationTariff.description = data.labelSQ;
          $scope.foundAuthorizationTafiff = "";
        } else {
          $scope.authorizationTariff.tariff = null;
          $scope.foundAuthorizationTafiff = "portal.tariff_not_found";
        }
      });
    };

    $scope.removeAuthorizationTariff = function (authorizationTariff) {
      authorizationTariffService.deleteAuthorizationTariff({id: authorizationTariff.id}, function () {
        authorizationTariffService.getAuthorizationTariffsForCaseId({id: $scope.entity.portalCase.id}, function (data) {
          $scope.authorizationTariffs = data;
          Messages.deleted();
        });
      })
    };

    $scope.editCase = function (portalCase) {
      console.log('vo novata edit funkcija');
      caseService.editAuthorizationCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (id) {
      caseService.submitAuthorizationCase(id, function (data) {
        Messages.saved();
        $scope.modalSubmitCaseConfirm.hide();
        ModalScrollLock.release();
        $location.path("/web_portal/web_portal_home_page/view_authorization_case/" + id);
        $timeout(function () {
          ModalScrollLock.release();
          $route.reload();
        });
      });
    };


    $scope.downloadAuthorizationTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_authorization_type_template/' + templateId);
      }
    };

    $scope.downloadGoodsTypeTemplateAttachment = function (templateId) {
      if(templateId) {
        Downloader.download('/data/rest/portal_attachments/get_goods_type_template/' + templateId);
      }
    };


    $scope.editAuthorization = function (authorization) {
      console.log('EDIT AUTHORIZATION ', authorization);
      caseService.editAuthorization(authorization, function (data) {
        $scope.authorization = data;
        Messages.saved();
      })
    };

    $scope.editPortalLicence = function (licence) {
      caseService.editPortalLicence(licence, function (data) {
        $scope.licence = data;
        Messages.saved();
      })
    };


    $scope.viewAuthorizationCase = function (id) {
      $location.path("/web_portal/web_portal_home_page/view_authorization_case/" + id);
    };


  }
]);
